import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import './lib/i18n';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AppShell from './layouts/AppShell';
import VersionCheck from './components/VersionCheck';

// Import terus secara langsung tanpa code-splitting mikro.
// Jumlah keseluruhan kod pages hanya ~200KB (~40KB gzip), menghapuskan
// kelewatan muat turun chunk, flicker skrin penuh, dan unmount AppShell.
import Login from './pages/Login';
import Register from './pages/Register';
import RegisterGuru from './pages/RegisterGuru';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

import BendaharaDashboard from './pages/bendahara/Dashboard';
import BendaharaPelajar from './pages/bendahara/Pelajar';
import BendaharaStudentDetail from './pages/bendahara/StudentDetail';
import BendaharaPengguna from './pages/bendahara/Pengguna';
import BendaharaTarif from './pages/bendahara/Tarif';
import BendaharaPengesahan from './pages/bendahara/Pengesahan';
import LapKutipan from './pages/bendahara/laporan/Kutipan';
import LapTunggakan from './pages/bendahara/laporan/Tunggakan';
import LapPelajar from './pages/bendahara/laporan/Pelajar';
import LapPengesahan from './pages/bendahara/laporan/Pengesahan';
import LapMesyuarat from './pages/bendahara/laporan/Mesyuarat';
import VerifikasiResit from './pages/VerifikasiResit';
import GuruDashboard from './pages/guru/Dashboard';
import OrangtuaDashboard from './pages/orangtua/Dashboard';

function PageFallback() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-background text-foreground">
      <div className="text-2xl font-bold">
        <span className="text-brand dark:text-blue-400">MTSR</span>
        <span className="text-emerald-600 dark:text-emerald-400">pay</span>
      </div>
      <div
        className="h-6 w-6 rounded-full border-2 border-brand/20 border-t-brand animate-spin"
        aria-label="Memuatkan…"
      />
    </div>
  );
}

function RootRedirect() {
  const { session, profile, loading } = useAuth();
  if (loading) return <PageFallback />;
  if (session && profile) return <Navigate to={`/${profile.role}`} replace />;
  if (profile) return <Navigate to={`/${profile.role}`} replace />;
  return <Navigate to="/masuk" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <VersionCheck />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/masuk" element={<Login />} />
          <Route path="/daftar" element={<Register />} />
          <Route path="/daftar-guru" element={<RegisterGuru />} />
          <Route path="/lupa-kata-laluan" element={<ForgotPassword />} />
          <Route path="/reset-kata-laluan" element={<ResetPassword />} />

          <Route path="/bendahara" element={<ProtectedRoute role="bendahara"><AppShell /></ProtectedRoute>}>
            <Route index element={<BendaharaDashboard />} />
            <Route path="pelajar" element={<BendaharaPelajar />} />
            <Route path="pelajar/:id" element={<BendaharaStudentDetail />} />
            <Route path="pengguna" element={<BendaharaPengguna />} />
            <Route path="tarif" element={<BendaharaTarif />} />
            <Route path="pengesahan" element={<BendaharaPengesahan />} />
            <Route path="laporan/kutipan" element={<LapKutipan />} />
            <Route path="laporan/tunggakan" element={<LapTunggakan />} />
            <Route path="laporan/pelajar" element={<LapPelajar />} />
            <Route path="laporan/pengesahan" element={<LapPengesahan />} />
            <Route path="laporan/mesyuarat" element={<LapMesyuarat />} />
          </Route>

          <Route path="/guru" element={<ProtectedRoute role="guru"><AppShell /></ProtectedRoute>}>
            <Route index element={<GuruDashboard />} />
          </Route>

          <Route path="/orangtua" element={<ProtectedRoute role="orangtua"><AppShell /></ProtectedRoute>}>
            <Route index element={<OrangtuaDashboard />} />
          </Route>

          <Route path="/verifikasi/:no" element={<VerifikasiResit />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="bottom-right" richColors closeButton />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
